import { Star, Quote } from "lucide-react";

export const ReviewCard = ({ review, className = "" }) => (
  <figure
    data-testid="review-card"
    className={`flex h-full flex-col rounded-2xl border border-stone-line bg-white p-7 shadow-soft ${className}`}
  >
    <Quote size={28} className="text-gold/40" />
    <div className="mt-3 flex gap-0.5">
      {Array.from({ length: review.rating }).map((_, i) => (
        <Star key={i} size={15} className="fill-gold text-gold" />
      ))}
    </div>
    <h4 className="mt-3 font-serif text-xl font-medium text-charcoal">{review.title}</h4>
    <blockquote className="mt-2 flex-1 text-[15px] leading-relaxed font-light text-slatey">
      “{review.text}”
    </blockquote>
    <figcaption className="mt-5 flex items-center justify-between border-t border-stone-line pt-4">
      <div>
        <span className="block font-medium text-charcoal">{review.name}</span>
        <span className="text-sm text-slatey">{review.country}</span>
      </div>
      <span className="rounded-full bg-sand px-3 py-1 text-xs font-medium text-charcoal">
        {review.ticket}
      </span>
    </figcaption>
  </figure>
);

export default ReviewCard;
